import request from '@/utils/request';

// 工会信息
export function unionList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/union/list',
    method: 'GET',
    params: params
  });
}
export function unionDetail(id) {
  return request({
    url: "/admin/union/detail/".concat(id),
    method: 'GET'
  });
}
export function unionCreate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/union/create',
    method: 'POST',
    data: data
  });
}
export function unionUpdate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/union/update/".concat(data.id),
    method: 'PUT',
    data: data
  });
}
export function unionDelete(id) {
  return request({
    url: "/admin/union/delete/".concat(id),
    method: 'DELETE'
  });
}
export function unionBatchDelete(ids) {
  return request({
    url: '/admin/union/batch/delete',
    method: 'DELETE',
    data: ids
  });
}
export function unionBatchUpdate(data) {
  return request({
    url: '/admin/union/batch/update',
    method: 'PUT',
    data: data
  });
}
export function unionBatchEnable(ids) {
  return request({
    url: '/admin/union/batch/enable',
    method: 'PUT',
    data: ids
  });
}
export function unionBatchDisable(ids) {
  return request({
    url: '/admin/union/batch/disable',
    method: 'PUT',
    data: ids
  });
}
export function unionExport() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/union/export',
    method: 'GET',
    params: params
  });
}
export function unionImport(formData) {
  return request({
    url: '/admin/union/import',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export function unionGetTemplate() {
  return request({
    url: '/admin/union/template',
    method: 'GET'
  });
}

// 工会会员 (后端支持 /admin/union/user 和 /admin/union/member 两个路径)
export function unionMemberList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/union/user/list',
    method: 'GET',
    params: params
  });
}
export function unionMemberDetail(id) {
  return request({
    url: "/admin/union/user/detail/".concat(id),
    method: 'GET'
  });
}
export function unionMemberCreate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/union/user/create',
    method: 'POST',
    data: data
  });
}
export function unionMemberUpdate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/union/user/update/".concat(data.id),
    method: 'PUT',
    data: data
  });
}
export function unionMemberDelete(id) {
  return request({
    url: "/admin/union/user/delete/".concat(id),
    method: 'DELETE'
  });
}
export function unionMemberBatchDelete(ids) {
  return request({
    url: '/admin/union/user/batch/delete',
    method: 'DELETE',
    data: ids
  });
}
export function unionMemberBatchUpdate(data) {
  return request({
    url: '/admin/union/user/batch/update',
    method: 'PUT',
    data: data
  });
}
export function unionMemberBatchEnable(ids) {
  return request({
    url: '/admin/union/user/batch/enable',
    method: 'PUT',
    data: ids
  });
}
export function unionMemberBatchDisable(ids) {
  return request({
    url: '/admin/union/user/batch/disable',
    method: 'PUT',
    data: ids
  });
}
export function unionMemberImport(formData) {
  return request({
    url: '/admin/union/user/import',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export function unionMemberExport() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/union/user/export',
    method: 'GET',
    params: params
  });
}
export function unionMemberGetTemplate() {
  return request({
    url: '/admin/union/user/template',
    method: 'GET'
  });
}

// 统计信息
export function unionStatistics() {
  return request({
    url: '/admin/union/statistics',
    method: 'GET'
  });
}

// 验证工会名称是否重复
export function checkUnionNameExists(name) {
  var excludeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var params = {
    name: name
  };
  if (excludeId) {
    params.excludeId = excludeId;
  }
  return request({
    url: '/admin/union/check/name',
    method: 'GET',
    params: params
  });
}

// 验证社会信用代码是否重复
export function checkSocialCreditCodeExists(socialCreditCode) {
  var excludeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var params = {
    socialCreditCode: socialCreditCode
  };
  if (excludeId) {
    params.excludeId = excludeId;
  }
  return request({
    url: '/admin/union/check/socialCreditCode',
    method: 'GET',
    params: params
  });
}
export function unionMemberStatistics(unionId) {
  var params = unionId ? {
    unionId: unionId
  } : {};
  return request({
    url: '/admin/union/user/statistics',
    method: 'GET',
    params: params
  });
}